import { useFiltersReturn } from "../hooks/use-filters";
import { Filter } from "../shared/types";
import { Box, Chip, Skeleton } from "@mui/material";
import useFetch from "@/hooks/use-fetch";
import { useEffect } from "react";
import { extractMessageFromError } from "@/shared/notification";

export default function FilterChip({
    filter,
    filterData,
}: {
    filter: Filter,
    filterData: useFiltersReturn
}) {
    const renderLabel = () => {
        if (filter.type === "model") return <ModelFilterChipLabel value={filter.value} getCriteria={filter.getCriteria}/>
        return filter.getCriteria();
    }

    const handleRemoveFilter = () => {
        const filteredFilter = (keys: string[]) => {
            const newFilterData = { ...filterData.filterData };
            for (const key of keys) delete newFilterData[key];
            return newFilterData;
        }

        switch (filter.type) {
            case "string":
            case "select":
            case "model":
                filterData.setFilterData(filteredFilter([filter.name]));
                return;
            case "dateRange":
                filterData.setFilterData(filteredFilter([filter.fromName, filter.toName]));
                return;
        }
    }

    return <Chip
        label={renderLabel()}
        size="small"
        onDelete={handleRemoveFilter}
    />
}

function ModelFilterChipLabel({
    value,
    getCriteria
}: {
    value:string,
    getCriteria: () => Promise<string>
}) {
    const { value: label, loading, error, fetch } = useFetch(getCriteria)

    useEffect(() => { 
        fetch() 
    }, [value])

    if (loading) return <Skeleton><Box visibility={"hidden"}>Label = Placeholder</Box></Skeleton>
    if (error) return extractMessageFromError(error);
    return label;
}